import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SortOrder, TenantsSortFieldEnum, type TenantsQueryModel } from 'api/hu'
import { RootState } from 'appHooks'
import { DEFAULT_PAGE_TAKE } from 'shared/constants/filters'

export const tenantsListInitialFilters: TenantsQueryModel = {
  searchText: null,
  sortColumn: TenantsSortFieldEnum.propertyNumber,
  sortorder: SortOrder.Ascending,
  take: DEFAULT_PAGE_TAKE,
  skip: 0,
}

const tenantsFiltersSlice = createSlice({
  name: 'tenantsFilters',
  initialState: tenantsListInitialFilters,
  reducers: {
    patchTenantsFilters: (
      state,
      action: PayloadAction<Partial<TenantsQueryModel>>
    ) => ({ ...state, ...action.payload }),
    resetTenantsFilters: () => tenantsListInitialFilters,
  },
})

export const getTenantsFilters = (state: RootState) => state.tenantsFilters

export const { patchTenantsFilters, resetTenantsFilters } =
  tenantsFiltersSlice.actions

export default tenantsFiltersSlice
